import { dataNotAvailable, isOld } from '@@/utils/CommonUtils';

export default {
  props: {
    dailySnow: {
      type: Object,
      default: null,
    },
  },

  computed: {
    authorName() {
      return this.dailySnow?.post?.author?.name;
    },

    authorPhotoUrl() {
      return this.dailySnow?.post?.author?.photo_url;
    },

    dailySnowName() {
      return this.dailySnow?.name;
    },

    isOldPost() {
      return this.postPostedAt ? isOld(this.postPostedAt) : undefined;
    },

    postImageUrl() {
      return this.dailySnow?.post?.image_url;
    },

    postSummary() {
      return this.dailySnow?.post?.summary;
    },

    postTitle() {
      return this.dailySnow?.post?.title;
    },

    postPostedAt() {
      return this.dailySnow?.post?.posted_at;
    },

    postPostedAtClassName() {
      const classNames = ['tw-text-sm', 'tw-font-normal', 'tw-mr-2 md:tw-mr-0'];

      if (!this.postPostedAt || this.isOldPost) {
        classNames.push('text-saturated-red-color');
      }
      else {
        classNames.push('text-light-color');
      }

      return classNames.join(' ');
    },

    postPostedAtText() {
      return this.postPostedAt
        ? this.$dayjs.utc(this.postPostedAt).timeAgo()
        : dataNotAvailable;
    },

    postUrl() {
      return `/dailysnow/${this.dailySnow.slug}/post/${this.dailySnow.post.id}`;
    },
  },
};
